// material-ui
import { useTheme } from '@mui/material/styles';
// import LogoPrimary from "../../assets/images/logo/CraneLogoLight.png"
// import LogoPrimary from "../../assets/images/logo/CraneLogo.png"
import { ThemeMode } from 'types/config';
import useThemeConfig from 'hooks/useThemeConfig';
import { styled } from '@mui/system';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

const StyledLogo = styled('img')({
  height: '50px',
  width: '150px'
});

// ==============================|| LOGO SVG ||============================== //

const LogoMain = ({ reverse, ...others }: { reverse?: boolean }) => {
  const theme = useTheme();
  const { themeConfig } = useThemeConfig();
  
  // Get logo URL from theme config, fallback to default images
  const LogoPrimary = themeConfig?.icons?.logo_path?.url;
  const LogoPrimaryLight = themeConfig?.icons?.logo_light_path?.url;
  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? logoDark : logo} alt="icon logo" width="100" />
     *
     */
    <StyledLogo src={theme.palette.mode === ThemeMode.DARK ? LogoPrimary : LogoPrimaryLight} alt="QuikStep" />
  );
};

export default LogoMain;
